import { Layout } from "antd"
import { NAME_SPACE } from "constants/app-paths"
import { useCallback } from "react"
import { useTranslation, withTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import AppFooter from "layout/footer"
import AppHeader from "layout/header"
import styles from "./index.module.less"
import Container from "components/common/container/contianer"

const { Content } = Layout

const HIDE_HEADER_PATHS_LIST = ["login"]
const HIDE_FOOTER_PATHS_LIST = ["login"]

const AppLayout = ({ children, i18n, showFooter = false, showHeader = false }) => {
  const location = useLocation()
  const { pathname } = location
  let startingPathName = pathname.split("/")[1]

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const isLoggedIn = useSelector(state => state.app.auth?.isLoggedIn)

  const renderFooter = !HIDE_FOOTER_PATHS_LIST.some(path => path === startingPathName) || showFooter
  const renderHeader = !HIDE_HEADER_PATHS_LIST.some(path => path === startingPathName) || showHeader

  const { locale } = useSelector(state => state?.app?.configs || "en")

  const onClickMenuItem = e => {
    if (e.domEvent.ctrlKey || e.domEvent.metaKey || e.domEvent.button === 2) {
      return
    }
  }

  const checkIfPathMatches = useCallback(
    modulePath => {
      const browserPath = window.location.pathname
      let namespace = browserPath.split("/").filter(item => NAME_SPACE.includes(item))
      return !!browserPath.replace("/" + namespace[0], "").startsWith(modulePath?.split("?")[0])
    },
    [window.location.pathname]
  )

  return (
    <Layout hasSider={false}>
      <Layout>
        {renderHeader && <AppHeader onClickMenuItem={onClickMenuItem} locale={locale} isLoggedIn={isLoggedIn} />}

        <Container>
          <Content className={styles.content}>{children}</Content>
        </Container>

        {renderFooter && <AppFooter onClickMenuItem={onClickMenuItem} locale={locale} />}
      </Layout>
    </Layout>
  )
}

export default withTranslation()(AppLayout)
